var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pay-pending-page"},[_c('div',{staticClass:"pay-pending-content"},[_c('div',{staticClass:"pay-pending-title"},[_c('span',[_vm._v("等待支付")])])])])
}]

export { render, staticRenderFns }